import classNames from "classnames";
import { ReactComponent as CopyIcon } from "assets/images/icons/copy.svg";
import copyToClipboard from "copy-to-clipboard";
import { useNotification } from "hooks/utils/useNotification";
import { NotificationStatus } from "components/Notification/types";
import { useIntl } from "react-intl";
import { messages } from "./messages";

import "./styles.scss";

export const DetailsField: React.FC<{
  label: string | JSX.Element;
  value: string | JSX.Element;
  key?: string;
  className?: string;
  copy?: boolean;
}> = ({ label, value, key, className, copy }) => {
  const { showNotification } = useNotification();
  const { formatMessage } = useIntl();

  const copyText = () => {
    if (typeof value === "string") {
      copyToClipboard(value);

      showNotification({
        title: formatMessage(messages.notificationTitle),
        message: formatMessage(messages.defaultNotificationMessage),
        status: NotificationStatus.SUCCESS,
      });
    }
  };

  return (
    <div
      className={classNames(className, "flex flex-col overflow-hidden")}
      key={key}
    >
      <span className="text-lg text-[--color-neutral-0]">{label}</span>
      <div className="flex items-center gap-2">
        <span className="w-full text-wrap text-2xl font-bold text-[--color-neutral-0]">
          {value}
        </span>
        {copy && (
          <CopyIcon
            className="history-details-field__icon h-4 w-4 cursor-pointer"
            type="button"
            onClick={() => copyText()}
          />
        )}
      </div>
    </div>
  );
};
